<template>
  <v-layout row wrap justify-center class="authentication">
    <div class="authBox">
      <template v-if="state === 'signedOut'">
        <amplify-sign-in></amplify-sign-in>
      </template>
      <template v-if="state === 'forgotPassword'">
        <amplify-forgot-password></amplify-forgot-password>
      </template>
      <template v-if="state === 'signUp'">
        <amplify-sign-up class="sign-up" :signUpConfig="signUpConfig"></amplify-sign-up>
      </template>
      <template v-if="state === 'confirmSignUp'">
        <amplify-confirm-sign-up ref="auth"></amplify-confirm-sign-up>
      </template>
      <div v-if="error" class="customError">{{ error }}</div>
    </div>
    <!-- <template v-if="state === 'signedIn'">
      <amplify-sign-out></amplify-sign-out>
    </template>-->
    <div v-if="getExtras" class="extras">
      <h2>
        Hey
        <span>{{ user.username }}</span>, we need a couple more items to get started
      </h2>
      <v-form>
        <v-container class="pa-0 mt-4">
          <v-layout row wrap>
            <v-flex xs4>
              <v-text-field outline v-model="extraInfo.ssn" label="SSN" required></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field outline v-model="extraInfo.acc_num" label="Account Number" required></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field outline v-model="extraInfo.dob" label="Date of Birth" required></v-text-field>
            </v-flex>
          </v-layout>
          <v-btn color="#40a7c7" class="submit ma-0" @click="sendDetails">Submit</v-btn>
        </v-container>
      </v-form>
    </div>
  </v-layout>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { Hub, Logger } from "aws-amplify";
import { mapState } from "vuex";
export default {
  name: "authentication",
  async created() {
    // changes state depending on authorization
    AmplifyEventBus.$on("authState", info => {
      if (info === "signedIn" && this.confirmed) {
        this.$store.commit("user/setState", "signedIn");
      } else if (info === "signedIn" && !this.confirmed) {
        this.$store.commit("user/setState", "");
      } else {
        this.$store.commit("user/setState", info);
      }
      let message = "";
      if (info === "confirmSignUp") {
        message = "Please confirm registration";
        this.$sweet.fire({
          toast: true,
          type: "success",
          title: message,
          position: "top",
          showConfirmButton: false,
          timer: 3000
        });
      } else if (info === "signedOut") {
        message = "Please sign in";
        this.$sweet.fire({
          toast: true,
          type: "success",
          title: message,
          position: "top",
          showConfirmButton: false,
          timer: 3000
        });
      }
    });
    // sets up listener for events
    this.auth();
    await this.checkUser();
  },
  data() {
    return {
      success: false,
      userLoggedIn: false,
      getExtras: false,
      error: "",
      extraInfo: {
        dob: "",
        ssn: "",
        acc_num: ""
      },
      userAtt: "",
      signUpConfig: {
        signUpFields: [
          //   {
          //     label: "First Name",
          //     key: "given_name",
          //     required: true,
          //     displayOrder: 0,
          //     type: "string"
          //   },
          //   {
          //     label: "Last Name",
          //     key: "family_name",
          //     required: true,
          //     displayOrder: 1,
          //     type: "string"
          //   },
          {
            label: "Hide Me",
            key: "phone_number",
            required: false,
            type: "string",
            displayOrder: 6,
            value: "0000000000"
          }
        ]
      }
    };
  },
  computed: {
    ...mapState("user", ["user", "state", "confirmed"])
  },
  watch: {
    state() {
      this.error = "";
    }
  },
  methods: {
    auth() {
      const alex = new Logger("Alexander_the_auth_watcher");
      alex.onHubCapsule = async capsule => {
        //console.log("new event", capsule);
        let error = capsule.payload.data.message;
        // console.log(capsule);
        this.error = "";
        switch (capsule.payload.event) {
          case "signIn":
            let user = await this.$Amplify.Auth.currentAuthenticatedUser({
              bypassCache: true
            });
            this.$store.commit("user/setUser", user);
            // console.log(user);
            break;
          case "signUp":
            this.error = error;
            break;
          case "signOut":
            this.success = false;
            //alex.error("user signed out");
            break;
          case "signIn_failure":
            if (error === "User is not confirmed.") {
              this.$store.commit("user/setState", "confirmSignUp");
            } else if (
              error === "UserMigration failed with error no user found." ||
              error === "User does not exist."
            ) {
              this.error = "User Not Found";
            } else if (
              error === "Incorrect username or password." ||
              error === "UserMigration failed with error password incorrect."
            ) {
              this.error = "Password Incorrect";
            } else {
              alex.error("sign in failed");
            }
            break;
          case "signUp_failure":
            if (
              error ===
              "PreSignUp failed with error A user with the same email address exists."
            ) {
              this.error = "A user with the same email already exists.";
            } else this.error = error;
            break;
          case "configured":
            //alex.error("the Auth module is configured");
            break;
        }
      };
      Hub.listen("auth", alex);
    },
    async checkUser() {
      try {
        let user = await this.$Amplify.Auth.currentAuthenticatedUser({
          bypassCache: true
        });
        this.$store.commit("user/setUser", user);
        this.$store.commit("user/setState", "signedIn");
      } catch (error) {
        this.$store.commit("user/setState", "signedOut");
      }
    },
    async checkProperty() {
      //   console.log("im checking the property");
      //   console.log(this.user);
      if (this.user.attributes.hasOwnProperty("custom:alerus360id")) {
        this.$store.commit("user/setConfirmed");
        console.log("im confirming from check property");
        this.$store.commit("user/setState", "signedIn");
      } else {
        // console.log("im here instead");
        this.getExtras = true;
      }
    },
    async checkUserDetails() {
      const { data } = await $unAuthUser.post(
        "/",
        {
          query: getUser,
          variables: {
            username: this.extraInfo.ssn
          }
        },
        {
          headers: {
            Authorization: this.user.signInUserSession.idToken.jwtToken
          }
        }
      );
    },
    async sendDetails() {
      const { data } = await $unAuthUser.post(
        "/",
        {
          query: getUserInfo,
          variables: {
            ssn: this.extraInfo.ssn
          }
        },
        {
          headers: {
            Authorization: this.user.signInUserSession.idToken.jwtToken
          }
        }
      );
      let info = data.data.getUserInfo;
      //console.log(info);
      if (info === null) {
        this.$sweet.fire({
          title: "User not found",
          text: "Please check your SSN number",
          type: "error",
          showConfirmButton: true
        });
      } else if (info.accNum !== this.extraInfo.acc_num) {
        this.$sweet.fire({
          title: "Account not found",
          text: "Please check your account number",
          type: "error",
          showConfirmButton: true
        });
      } else if (info.dateOfBirth !== this.extraInfo.dob) {
        this.$sweet.fire({
          title: "Account error",
          text: "Please check your DOB",
          type: "error",
          showConfirmButton: true
        });
      } else if (this.checkInfo(info)) {
        this.addUserProps(info);
      } else if (!this.checkInfo(info)) {
        console.log("error");
      }
    },
    checkInfo(info) {
      if (
        this.extraInfo.ssn === info.ssn &&
        this.extraInfo.dob === info.dateOfBirth &&
        this.extraInfo.acc_num === info.accNum
      )
        return true;
      else return false;
    },
    async addUserProps(data) {
      try {
        let newData = {
          "custom:alerus360id": data.alerus360id,
          "custom:cif": data.cif,
          "custom:dateofbirth": data.dateOfBirth
        };
        this.userAtt = await this.$Amplify.Auth.updateUserAttributes(
          this.user,
          newData
        );
        // let currUser = this.user.attributes;
        // Object.assign(currUser, newData);
        // this.$store.commit("user/setUserAtts", currUser);
        let user = await this.$Amplify.Auth.currentAuthenticatedUser({
          bypassCache: true
        });
        //console.log(user);
        //this.$store.commit("user/setConfirmed");
        this.$store.commit("user/setState", "signedOut");
        this.getExtras = false;
        this.$sweet.fire({
          toast: true,
          type: "success",
          title: "Please sign in to complete registration.",
          position: "top",
          showConfirmButton: false,
          timer: 3000
        });
        //this.error = "Please sign in to complete registration.";
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss">
.authentication {
  margin: 0 2rem;
  a {
    color: #0b2a4a;
  }
  button {
    background-color: #0b2a4a;
    &:active {
      background-color: #0b2a4a;
    }
    &:focus {
      outline: none;
    }
  }
  .error {
    margin-top: 1.5rem;
    color: #fd0000;
  }
}
.error {
  display: none;
}
.extras {
  //background-color: #fff;
  width: 50%;
  margin: 0 auto;
  display: inline-block;
  padding: 2rem;
  border-radius: 2px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  span {
    color: #40a7c7;
  }
  .flex-ct {
    width: 100%;
  }
  h2 {
    font-weight: initial;
  }
  h3 {
    margin-top: 0;
    width: 100%;
    font-size: 1.25rem;
    font-weight: initial;
  }
  .items {
    width: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column;
    // align-items: center;
    & > div {
      display: inline-flex;
      margin: 0.25rem 0;
      text-align: left;
      label {
        padding-right: 0.5rem;
        font-size: 1rem;
      }
    }
  }
  .submit {
    margin-top: 1.5rem;
    font-size: 1.1rem;
    color: #fff;
    padding: 0.5rem 1.5rem;
    font-family: "the-serif";
    cursor: pointer;
  }
}
.sign-up {
  .Section__sectionBody___3DCrX {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    & > div {
      width: 49%;
    }
    & > div:last-child {
      display: none;
    }
  }
}
.success {
  background-color: #fff;
  display: inline-block;
  padding: 2rem;
  border-radius: 2px;
  h3 {
    margin-top: 0;
  }
}
.authBox {
  background-color: #fff;
  box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  & > div:first-child {
    margin-bottom: 0;
    box-shadow: none;
  }
}
.customError {
  padding: 0 40px 35px 40px;
  color: red;
  position: relative;
  z-index: 1;
  margin-top: -15px;
}
</style>
